import Axios, { AxiosError, AxiosRequestConfig, Method } from 'axios'

import { ApiError, GeneralError } from '../Interfaces/ErrorInterfaces'
import { TOKEN_NAME } from '../reducers/token'

interface QueryParams {
  [key: string]: string
}

export const getToken = () => window.sessionStorage.getItem(TOKEN_NAME)
export const headersWithToken = (headers = {}) => ({ ...headers, authorization: `Bearer ${getToken()}` })

const handleError = (error: AxiosError): Promise<ApiError | GeneralError> => {
  if (error.response) {
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
      status: error.response.status,
      message: (error.response.data && error.response.data.message) || error.response.statusText || error.message,
    })
  }
  // eslint-disable-next-line prefer-promise-reject-errors
  return Promise.reject({ message: error.message })
}

const request = (config: AxiosRequestConfig, withToken: boolean) => {
  const finalConfig = withToken ? { ...config, headers: headersWithToken(config.headers) } : config
  return Axios.request(finalConfig)
    .then((response) => response.data)
    .catch((error) => handleError(error))
}

export const Get = (url: string, withToken: boolean = true, params?: QueryParams) => {
  const config = { url, params, method: 'get' as Method }
  return request(config, withToken)
}

export const Put = (url: string, data?: object, withToken: boolean = true, params?: QueryParams) => {
  const config = { url, params, method: 'put' as Method, data }
  return request(config, withToken)
}

export const Post = (url: string, data?: object, withToken: boolean = true, params?: QueryParams) => {
  const config = { url, params, method: 'post' as Method, data }
  return request(config, withToken)
}

export const Delete = (url: string, withToken: boolean = true, params?: QueryParams) => {
  const config = { url, params, method: 'delete' as Method }
  return request(config, withToken)
}
